import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const logoutApi = async (user) => {
  const data = user || {};
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Logout.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
